import { DEFAULT_BYO_SHOP_CODE } from "@stadium/constants/shop";

export const BYSTADIUM_PROD_HOSTNAME = "https://www.bystadium.com";
export const BYSTADIUM_DASHBOARD_PROD_HOSTNAME = "https://app.bystadium.com";
export const BYSTADIUM_DOMAIN_NAME = "app.bystadium.com";

export const BYSTADIUM_DASHBOARD_HOSTNAME =
  process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME ||
  process.env.NEXT_PUBLIC_SHOPS_DASHBOARD_HOSTNAME ||
  BYSTADIUM_DASHBOARD_PROD_HOSTNAME;

export const BYSTADIUM_HOSTNAME =
  process.env.NEXT_PUBLIC_BYSTADIUM_HOSTNAME || BYSTADIUM_PROD_HOSTNAME;

export const DASHBOARD_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/dashboard`;

export const BYSTADIUM_SHOP_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/shops`;
export const BYSTADIUM_MY_SHOP_URL = `${BYSTADIUM_SHOP_URL}/all`;
export const BYSTADIUM_USER_DASHBOARD_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/dashboard`;

export const COMPANY_SPACE_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/admin`;

export const KITS_DASHBOARD_ROUTE = `${BYSTADIUM_SHOP_URL}/kits`;
export const SEND_ITEMS_ROUTE = `${KITS_DASHBOARD_ROUTE}?send-items=true`;

export const BYSTADIUM_SHOP_MY_PURCHASES = `${BYSTADIUM_SHOP_URL}/my-orders/purchases`;

export const BYSTADIUM_SHOP_CHOOSE_TEMPLATE = `${BYSTADIUM_SHOP_URL}/templates`;

export const BYSTADIUM_SHOP_INTEGRATIONS = `${BYSTADIUM_SHOP_URL}/integrations`;

export const LOCKER_DASHBOARD_URL = `${BYSTADIUM_DASHBOARD_HOSTNAME}/locker`;
export const LOCKER_DASHBOARD_TAB_URL = `${LOCKER_DASHBOARD_URL}/[viewType]/[tab]`;
export const LOCKER_DASHBOARD_COLLECTION_VIEW_URL = `${LOCKER_DASHBOARD_URL}/collections/all`;

export const BYSTADIUM_CATALOG = `${BYSTADIUM_HOSTNAME}/go/catalog`;

export const BYSTADIUM_REDEEM_GIFT_CODE_ROUTE = `${BYSTADIUM_HOSTNAME}/go/redeem-gift-code`;

export const STADIUM_USERS_URL =
  process.env.NEXT_PUBLIC_STADIUM_USERS_URL ||
  process.env.REACT_APP_STADIUM_USERS_URL ||
  "https://account.bystadium.com";

export const MERGED_STADIUM_USERS_URL = BYSTADIUM_DASHBOARD_HOSTNAME;

export const BYSTADIUM_URL = "https://www.bystadium.com/";

export const BYSTADIUM_BOOK_A_CALL = `${BYSTADIUM_HOSTNAME}/go/book-a-call`;

export const BYSTADIUM_GET_A_QUOTE = `${BYSTADIUM_HOSTNAME}/go/get-a-quote`;

export const SNACKMAGIC_URL =
  process.env.NEXT_PUBLIC_SNACKMAGIC_TEST_URL || "https://www.snackmagic.com/";
export const SWAGMAGIC_URL =
  process.env.NEXT_PUBLIC_SWAGMAGIC_TEST_URL || "https://www.swagmagic.com/";

export const SNACKMAGIC_SEND_TREAT_URL = `${SNACKMAGIC_URL}send-a-treat`;
export const SNACKMAGIC_ORDER_DETAIL = `${SNACKMAGIC_URL}dashboard/treats/:number/status`;
export const SNACKMAGIC_INCOMPLETE_ORDER_SETUP = `${SNACKMAGIC_URL}dashboard/treats/:number/setup`;
export const SNACKMAGIC_SHIPMENT_TRACKING_URL = `${SNACKMAGIC_URL}orders/track/:number`;

export const getCreateNewShopRoute = ({
  shopCode = DEFAULT_BYO_SHOP_CODE,
  shopNumber,
  returnTo = null,
  workspaceSlug,
}) => {
  const params = new URLSearchParams({
    createShop: true,
    ...(returnTo && { returnTo }),
  });
  const slug = workspaceSlug ? `${shopCode}--${workspaceSlug}` : shopCode;
  return `${BYSTADIUM_HOSTNAME}/stores/create/${slug}/${shopNumber}?${params}`;
};

export const getSnackmagicOrderDetailPage = (orderNumber) =>
  SNACKMAGIC_ORDER_DETAIL.replace(":number", orderNumber);

export const getSnackmagicIncompleteOrderSetupPage = (orderNumber) =>
  SNACKMAGIC_INCOMPLETE_ORDER_SETUP.replace(":number", orderNumber);

export const getSnackmagicOrderTrackingPage = (orderNumber) =>
  SNACKMAGIC_SHIPMENT_TRACKING_URL.replace(":number", orderNumber);

export const BYSTADIUM_MARKETING_URL =
  process.env.NEXT_PUBLIC_MARKETING_PAGE_HOSTNAME || BYSTADIUM_PROD_HOSTNAME;

export const UNAUTHENTICATED_PEER_TO_PEER = "https://www.bystadium.com/peer-to-peer";
export const UNAUTHENTICATED_CAMPAIGNS = "https://www.bystadium.com/campaigns";
export const UNAUTHENTICATED_IN_PERSON = "https://www.bystadium.com/in-person";

export const LOCKER_ITEM_PAGE = `${LOCKER_DASHBOARD_URL}/item`;

export const getRestockItemRoute = ({ slug, catalogNumber }) =>
  `${LOCKER_ITEM_PAGE}/${slug}-${catalogNumber?.toLowerCase()}/restock`;

export const CREATE_SHARED_WALLET_ROUTE = `${BYSTADIUM_DASHBOARD_HOSTNAME}/wallet/create/:walletId`;
